module.exports = __webpack_public_path__ + "img/Mohammed Faisal .b6f42462.jpg";